// extracted by mini-css-extract-plugin
export default {"button":"RBUDP","section":"pYLWp","sectionSelected":"PUe7b","removeBtn":"tEmGH","name":"t8FCa","inner":"yzZs9"};